import { render, staticRenderFns } from "./ShipmentRuleTable.vue?vue&type=template&id=1e37c87c"
import script from "./ShipmentRuleTable.vue?vue&type=script&lang=js"
export * from "./ShipmentRuleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports